import React, { useState, useEffect } from 'react';
import './ConfiguracionCuentaModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { updateUserField } from '../../../firebase/config';

export const ConfiguracionCuentaModal = ({ user, onClose }) => {
  // 🔹 LocalStorage
  const storedAlerts = localStorage.getItem(`user_${user?.uid}_sendAlerts`);
  const initialAlerts =
    storedAlerts !== null ? JSON.parse(storedAlerts) : user?.sendAlerts ?? false;

  const [sendAlerts, setSendAlerts] = useState(initialAlerts);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.uid) {
      localStorage.setItem(`user_${user.uid}_sendAlerts`, JSON.stringify(sendAlerts));
    }
  }, [sendAlerts, user]);

  if (!user) {
    return (
      <div className="config-modal-overlay">
        <div className="config-modal">
          <p>No se encontró información del usuario.</p>
        </div>
      </div>
    );
  }

  // 🔹 Formatear timestamp lastLogin (si lo usas)
  const lastLoginDate =
    user.lastLogin?.toDate
      ? user.lastLogin.toDate().toLocaleString('es-ES')
      : 'No disponible';

  // 🔹 Formatear timestamp registerDate
  const registerDateFormatted =
    user.registerDate?.toDate
      ? user.registerDate.toDate().toLocaleString('es-ES')
      : 'No disponible';

  const handleToggleAlerts = async () => {
    const newValue = !sendAlerts;
    setSendAlerts(newValue);

    try {
      setLoading(true);
      await updateUserField(user.uid, { sendAlerts: newValue });
      localStorage.setItem(`user_${user.uid}_sendAlerts`, JSON.stringify(newValue));
    } catch (error) {
      console.error('Error al actualizar sendAlerts:', error);
      alert('Hubo un problema al guardar los cambios.');
      setSendAlerts(!newValue);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="config-modal-overlay">
      <div className="config-modal">
        <button className="close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <h2>Configuración de cuenta</h2>

        <div className="config-content">
          <div className="info-row">
            <strong>Nombre de usuario:</strong>
            <span>{user.username || user.displayName || 'No especificado'}</span>
          </div>

          <div className="info-row">
            <strong>Email:</strong>
            <span>{user.email}</span>
          </div>

          <div className="info-row">
            <strong>Fecha de nacimiento:</strong>
            <span>{user.birthdate || 'No registrada'}</span>
          </div>

          <div className="info-row">
            <strong>Género:</strong>
            <span>
              {user.gender === 'male'
                ? 'Hombre'
                : user.gender === 'female'
                ? 'Mujer'
                : 'No especificado'}
            </span>
          </div>

          <div className="info-row">
            <strong>Provincia:</strong>
            <span>{user.province || 'No especificada'}</span>
          </div>

          <div className="info-row">
            <strong>Fecha de registro:</strong>
            <span>{registerDateFormatted}</span>
          </div>

          {/* 🔹 Toggle Send Alerts */}
          <div className="info-row toggle-row">
            <strong>Recibir mail con alertas:</strong>
            <label className="switch">
              <input
                type="checkbox"
                checked={sendAlerts}
                onChange={handleToggleAlerts}
                disabled={loading}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="config-footer">
          <FontAwesomeIcon icon={faCircleInfo} />
          <p>Los cambios se guardan automáticamente.</p>
        </div>
      </div>
    </div>
  );
};
